module.exports = {
      id: "vikatan-tv-usage",
      viewBox: "0 0 213 43",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#vikatan-tv",
      toString: function () {
        return this.url;
      }
    }